export enum ActuationOperation {
    Visita = 1,
    Contacto = 2,
    VisitaAusente = 3,
    ContactoFallido = 4,
    Solicitud = 5,
    GestionConMutua = 6,
    Comentarios = 7,
    InformeMedico = 8,
    DocumentoNoMedico = 9,
    Orden = 10,
    ContactoAdministrativo = 11,
    ContactoAdministrativoNoContesta = 12,
    PrimerContacto = 13,
    SmsEntregado = 14,
    SmsNoEntregado = 15,
    SolicitarAlta = 16,
    MantenerIt = 17,
    //VisitaVideoconsulta = 18,
    PedirCita,
    CitationFormal,
    Inspection,
    AltaNoConfirmada,
    AcknowledgementOfReceipt
}
